import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext';
import { translations } from '../locales/translations';
import './Header.css';

function Header() {
  const { language, setLanguage } = useContext(LanguageContext);
  const t = translations[language].nav;
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'zh' : 'en');
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo" onClick={closeMenu}>
            <span className="logo-icon">📈</span>
            <span className="logo-text">FutureTick</span>
          </Link>
          
          <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className={`nav-menu ${menuOpen ? 'active' : ''}`}>
            <Link to="/" className="nav-link" onClick={closeMenu}>{t.home}</Link>
            <Link to="/support" className="nav-link" onClick={closeMenu}>{t.support}</Link>
            <Link to="/privacy" className="nav-link" onClick={closeMenu}>{t.privacy}</Link>
            <button className="lang-toggle" onClick={toggleLanguage}>
              {language === 'en' ? '中文' : 'EN'}
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
